var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.calculatesAsa)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Bitte warte kurz bis die Berechnung fertig ist bevor du eine Stufe\n    aktivieren/deaktivieren kannst!\n  ")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('v-table',{attrs:{"url":"/api/v1/asa","attributes":[
      {
        attribute: 'duration_formatted',
        name: 'Dauer'
      },
      {
        attribute: 'update_page_url',
        name: 'Bearbeiten',
        type: 'ActionCell',
        label: 'Bearbeiten'
      },
      {
        attribute: 'update_url',
        name: 'Löschen',
        type: 'DeleteCell',
        label: 'Löschen'
      },
      {
        attribute: 'active',
        name: 'Aktiv?',
        type: 'ToggleCell',
        url: 'toggle_active_url',
        disabled: this.calculatesAsa
      }
    ]}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v("\n      Eine Asa ist ein Wiederanschreiben eines Mitglieds, nach dem dieses\n      Mitglied bereits in einem Dialog geschrieben hat, aber nicht mehr\n      antwortet. Sprich, die Moderation hat die letzte Nachricht geschrieben.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Eine Asa Stufe entspricht einer Nachricht. Das heißt, Wenn im System\n      eine ASA Stufe eingetragen ist, wird das Mitglied nach der letzten\n      Nachricht eines Moderators ein weiteres Mal angeschrieben. Bei 10 ASA\n      Stufen wird das Mitglied 10 Mal erneut angeschrieben.\n    ")])])}]

export { render, staticRenderFns }